import React, { Component } from 'react'
import { TweenMax, Power2 } from 'gsap'
import TimelineMax from 'gsap/TimelineMax'
import TransitionGroup from 'react-transition-group/TransitionGroup' // ES6
import { contentWidth } from 'lib/Utils'

// Components
import EntryList from 'components/EntryList'
import Entry from 'components/Entry'
import JobPositionList from 'components/JobPositionList'
import LocationList from 'components/LocationList'
import Service from 'components/Service'
import Page from 'components/Page'
import ChildrenOrHidden from 'components/ChildrenOrHidden'
import DrawerTitle from 'components/DrawerTitle'
import ServicesNavMobile from 'components/ServicesNavMobile'

import PropTypes from 'prop-types'
import $ from 'jquery'
import './index.scss'

class ContentDrawer extends Component {
  componentWillLeave (callback) {
    this.close(callback)
  }

  close (callback = null) {
    const el = this.container
    const timeline = new TimelineMax()
    timeline
      .to(el, 0.8, { x: '100%', ease: Power2.easeInOut, onComplete: callback })
      .to($(el).children('div'), 0.8, { x: '-20%', opacity: '0', ease: Power2.easeInOut, onComplete: callback }, 0)
  }

  open (callback = null) {
    const el = this.container
    const timeline = new TimelineMax()
    timeline
      .fromTo(el, 0.8, { x: '100%' }, { x: '0%', ease: Power2.easeInOut, onComplete: callback })
      .fromTo(
        $(el).children('div'),
        0.8,
        { x: '-20%', opacity: '0' },
        { x: '0%', opacity: '1', ease: Power2.easeInOut, onComplete: callback },
        0
      )
  }

  componentWillEnter (callback) {
    this.open(callback)
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.siteMenuVisible !== nextProps.siteMenuVisible) {
      if (nextProps.siteMenuVisible) {
        this.close()
      } else {
        this.open()
      }
    }
  }

  componentDidMount () {
    this.setContainerWidth()
  }

  componentDidUpdate () {
    this.setContainerWidth()
  }

  setContainerWidth () {
    // let containerWidth = (this.props.content.type === 'contact') ? 440 : contentWidth()
    // TweenMax.to(this.container, 0.6, { width: containerWidth, ease: Power2.easeOut })
  }

  render () {
    let content = this.props.content
    return (
      <main ref={el => { this.container = el; return false }} className={`content-drawer`}>
        <div>
          <TransitionGroup component='div'>
            <DrawerTitle title={content.title} showBackButton={(content.type === 'singlePost')} showSocialLinks={(content.type === 'singlePost')} />
          </TransitionGroup>
          <div className='content-drawer__content'>
            <TransitionGroup component={ChildrenOrHidden}>
              {
                (content.hasOwnProperty('item')) && content.type === 'service' &&
                <Service item={content.item} />
              }
            </TransitionGroup>
            <TransitionGroup component={ChildrenOrHidden}>
              {
                (content.hasOwnProperty('items')) &&
                <EntryList items={content.items} categories={content.categories} />
              }
            </TransitionGroup>
            <TransitionGroup component={ChildrenOrHidden}>
              {
                (content.hasOwnProperty('item') && content.item.type === 'post') > 0 &&
                <Entry item={content.item} />
              }
            </TransitionGroup>
            <TransitionGroup component={ChildrenOrHidden}>
              {
                (content.hasOwnProperty('offices')) && content.offices.length > 0 &&
                <JobPositionList offices={content.offices} />
              }
            </TransitionGroup>
            <TransitionGroup component={ChildrenOrHidden}>
              {
                (content.hasOwnProperty('locations')) && content.locations.length > 0 &&
                <LocationList locations={content.locations} />
              }
            </TransitionGroup>
            <TransitionGroup component={ChildrenOrHidden}>
              {
                this.props.content.type === 'page' &&
                <Page item={content.item} />
              }
            </TransitionGroup>
          </div>
          {
            (content.hasOwnProperty('item')) && content.type === 'service' &&
            <ServicesNavMobile services={this.props.listedServices} selectedService={this.props.selectedService} />
          }
        </div>
      </main>
    )
  }
}

ContentDrawer.propTypes = {
  content: PropTypes.object,
  siteMenuVisible: PropTypes.bool,
  className: PropTypes.string,
  listedServices: PropTypes.array,
  selectedService: PropTypes.number
}

export default ContentDrawer



// WEBPACK FOOTER //
// ./src/components/ContentDrawer/index.js